import React from "react";

const approachPoints = [
  "Treating the root cause",
  "Understanding your complete health history",
  "Strengthening your immune system naturally",
  "Providing safe remedies with no side effects",
  "Long-term healing and prevention",
];

export default function OurApproach() {
  return (
    <section id="approach">
      <div className="approach-section">

        {/* TITLE */}
        <div className="section-title">
          <span></span>
          <h2>OUR APPROACH</h2>
          <span></span>
        </div>

        {/* GRID */}
        <div className="approach-container">
          {approachPoints.map((point, index) => (
            <div className="approach-card" key={index}>
              <div className="check-icon">✔</div>
              <p>{point}</p>
            </div>
          ))}
        </div>

        {/* BOTTOM TEXT */}
        <div className="approach-footer">
          <p>
            Each patient receives a detailed consultation to understand
            physical, emotional, and lifestyle factors before prescribing remedies.
          </p>
        </div>

      </div>
    </section>
  );
}